"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPlayer = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var FormPlayer = function (_a) {
    var video = _a.video, setVideo = _a.setVideo, setUpload = _a.setUpload, id = _a.id, channel = _a.channel, user = _a.user;
    if (!id) {
        return react_1.default.createElement(storybook_1.Videos.FormUpload, { video: video, setUpload: setUpload });
    }
    return react_1.default.createElement(storybook_1.Players.Player, { user: user, channel: channel, id: "form-player-" + id, video: video, autoplay: video.type === 'live', setVideo: setVideo });
};
exports.FormPlayer = FormPlayer;
exports.FormPlayer.propTypes = {
    video: prop_types_1.default.shape({
        id: prop_types_1.default.number,
    }).isRequired,
};
exports.FormPlayer.defaultProp = {};
